import React, { useState } from "react";
import AuthTextInput from "../../components/common/commonTextInputs/authTextInput";
import bgImg from "../../assets/images/bgImg.png";
import brandLogo from "../../assets/logos/brandLogo.svg";
import AuthButton from "../../components/common/commonButtons/authButton";
import {  useNavigate } from "react-router";
import { UserChangePasswordAPI } from "../../services/authServices";
import CommonSnackbar from "../../components/common/toastMessage";
interface ChangePasswordState {
  oldPassword: string;
  password: string;
  confirmPassword: string;
  errors: {
    oldPasswordError: string;
    passwordError: string;
    confirmPasswordError: string;
    validationError: string;
    apiError?: string;
  };
}

const ChangePassword: React.FC = () => {
  const [changePassword, setChangePassword] = useState<ChangePasswordState>({
    oldPassword: "",
    password: "",
    confirmPassword: "",
    errors: {
      oldPasswordError: "",
      passwordError: "",
      confirmPasswordError: "",
      validationError: "",
    },
  });
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        color: "green",
  });

  const navigate = useNavigate();
  const [error, setErrors] = useState<any>({
    wholeError: false,
  });

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      oldPasswordError: "",
      passwordError: "",
      confirmPasswordError: "",
      validationError: "",
    };

    if (changePassword.oldPassword.trim().length < 8) {
      newErrors.oldPasswordError = "Old password must be at least 8 characters.";
      isValid = false;
    }

    if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!\"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])[A-Za-z\d!\"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+$/.test(
        changePassword.password
      )
    ) {
      newErrors.passwordError =
        "New password must contain 1 uppercase letter, 1 number, and 1 special character.";
      isValid = false;
    }

    if (changePassword.password !== changePassword.confirmPassword) {
      newErrors.confirmPasswordError = "Passwords do not match.";
      isValid = false;
    }

    setChangePassword((prev) => ({ ...prev, errors: newErrors }));
    return isValid;
  };

  // Handle input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setChangePassword((prev) => ({
      ...prev,
      [name]: value,
      errors: { ...prev.errors, [`${name}Error`]: "" },
    }));
  };

  const handleSubmit = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("inviteToken");

    if (!validateForm()) return;

    try {
      const userObject = {
        oldPassword: changePassword.oldPassword,
        password: changePassword.confirmPassword,
      };

      const value = await UserChangePasswordAPI(token, userObject);
      // console.log(value, "valueeee");

      if (value?.status === 200) {
        setSnackbar({
          open: true,
          message: value.message,
          color: "green",
        });
        setTimeout(() => {
        navigate("/");
        }, 800);
      } else if (value?.status === 400) {
        setChangePassword((prev) => ({
          ...prev,
          errors: {
            ...prev.errors,
            apiError: value?.message || "Something went wrong.",
          },
        }));
      }
    } catch (e: any) {
      console.log(e, "err:");
      setChangePassword((prev) => ({
        ...prev,
        errors: {
          ...prev.errors,
          apiError: e?.message || "Something went wrong.",
        },
      }));
    }
  };

  const handleLogin = () => {
    navigate("/")
  }

  return (
    <>
      <div
        className="flex justify-center items-center w-[100%] h-screen bg-cover bg-center text-white"
        style={{ backgroundImage: `url(${bgImg})` }}
      >
        <div className="!w-[400px] flex justify-center items-center bg-authContainerBg border border-authContainerBg !rounded-2xl">
          <div className="!m-[1rem] w-[75%] flex flex-col justify-center items-center !my-[2rem]" >
            <img src={brandLogo} alt="Awesome-Logo" className="!mb-[0.5rem]" />
            <p className="font-bold text-[1.3rem]">Reset Password !</p>
            <p className="text-[0.7rem] ">Create New Password</p>
            <AuthTextInput
              placeholder="Enter Old Password"
              types="password"
              name="oldPassword"
              value={changePassword.oldPassword}
              onChange={handleChange}
            />
            {changePassword.errors.oldPasswordError && (
              <span className="text-[0.8rem] text-red-500">
                {changePassword.errors.oldPasswordError}
              </span>
            )}

            <AuthTextInput placeholder="Enter New Password" types="password"
              name="password"
              value={changePassword.password}
              onChange={handleChange} />
            {changePassword.password.length < 8 ? (
              <span className="text-[0.8rem] text-red-500 ">
                {changePassword.errors.passwordError}
              </span>
            ) : (
              changePassword.errors.passwordError && (
                <span className="text-[0.8rem] text-red-500 ">
                  {changePassword.errors.passwordError}
                </span>
              )
            )}
            <AuthTextInput placeholder="Confirm New Password" types="password"
              name="confirmPassword"
              value={changePassword.confirmPassword}
              onChange={handleChange} />
            {changePassword.password !==
              changePassword.confirmPassword && (
                <span className="text-[0.8rem] text-red-500">
                  {changePassword.errors.confirmPasswordError}
                </span>
              )}
            {error.wholeError && (
              <span className="text-[0.8rem] text-red-500">
                {changePassword.errors.validationError}
              </span>
            )}
            {changePassword.errors.apiError && (
              <span className="text-[0.8rem] text-red-500 !mt-4 text-center">
                {changePassword.errors.apiError}
              </span>
            )}
             {changePassword.errors.apiError &&<AuthButton
              message="Login" onClick={handleLogin}
              classes="bg-gradient-to-r from-[#3BEBAA4D] to-[#3983DD] !font-bold !text-[0.7rem] !normal-case !text-white w-[100%] !rounded-[5px] h-[2.3rem] !p-[0.9rem] !mt-[1rem]"
            /> }
            <AuthButton
              message="Continue" onClick={handleSubmit}
              classes="bg-gradient-to-r from-[#3BEBAA4D] to-[#3983DD] !font-bold !text-[0.7rem] !normal-case !text-white w-[100%] !rounded-[5px] h-[2.3rem] !p-[0.9rem] !mt-[1rem]"
            />
          </div>
        </div>
        <CommonSnackbar
        open={snackbar.open}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        message={snackbar.message}
        backgroundColor={snackbar.color}
      />
      </div>
    </>
  );
};

export default ChangePassword;
